export const VERSION = '0.100.1'; // x-release-please-version
